export default __webpack_public_path__ + "static/media/logo_red_vacunacion_radar_jalisco.4d399354.png";